import React from 'react';
import { useTranslation } from 'react-i18next';

interface InformationCardContentLabelProps {
  description: string;
  id: string;
}

const InformationCardContentLabel: React.FC<InformationCardContentLabelProps> = ({ description, id }) => {
  const { t } = useTranslation();
  return (
    <span key={`${id}-label`} className="paragraph">
      {t(description)}
    </span>
  );
};

export default InformationCardContentLabel; 